import React, { createContext, useEffect, useState } from "react";
import { api } from "./api";
import axios from "axios";

export const UserContext = createContext();

const ContextProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sellerList, setSellerList] = useState();
  const isLoggedIn = localStorage.getItem("isLogging");
  const [loader, setLoader] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [categories, setCategories] = useState();

  const [subCategories, setSubCategories] = useState();

  const getUserData = async () => {
    try {
      setLoading(true);
      const response = await api.get("/api/user/getDataByToken");
      setUser(response.data.data);
    } catch (error) {
      console.log(error);
      setUser(null);
      localStorage.removeItem("isLogging");
    } finally {
      setLoading(false);
    }
  };

  const getAllsellers = async () => {
    try {
      const response = await api.get("api/seller/getAllSeller");
      setSellerList(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };
  const getCategories = async () => {
    try {
      const response = await axios.get(
        "https://api.products.jungleboosh.com/api/category/getCategories",
      );

      setCategories(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getAllSubcategories = async () => {
    try {
      const response = await axios.get(
        "https://api.products.jungleboosh.com/api/category/getAllsubcategoris",
      );

      setSubCategories(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      getUserData();
      getAllsellers();
      getCategories();
      getAllSubcategories();
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <UserContext.Provider
      value={{
        user,
        loading,
        categories,
        getUserData,
        sellerList,
        setLoader,
        loader,
        setToggle,
        toggle,
        subCategories
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default ContextProvider;
